import { useRef } from 'react'
import { usePrevious } from './use-previous'

type NoneToVoidFunction = () => void

export function useSyncEffect<T extends readonly any[]>(
  effect: (args: T | readonly []) => NoneToVoidFunction | void,
  dependencies: T,
) {
  const prevDeps = usePrevious<T>(dependencies)
  const cleanupRef = useRef<NoneToVoidFunction | void>()

  if (!prevDeps || dependencies.some((d, i) => d !== prevDeps[i])) {
    if (cleanupRef.current) cleanupRef.current()
    cleanupRef.current = effect(prevDeps || []) ?? undefined
  }
}
